// tslint:disable: max-line-length

import {
  Component,
  Input,
  AfterContentInit,
  ElementRef,
  HostBinding,
  TemplateRef,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'suka-label',
  template: `
    <label
      [for]="id"
      class="label"
      [ngClass]="{
        'skeleton': skeleton
      }">
      <ng-content></ng-content>
    </label>
    <div *ngIf="!skeleton && helperText" class="form__helper-text">{{helperText}}</div>
    <div class="text-input__field-wrapper" [attr.data-invalid]="(invalid ? true : null)" #wrapper>
      <suka-icon *ngIf="invalid" icon="alert-circle" class="text-input__invalid-icon text-area__invalid-icon"></suka-icon>
      <suka-icon *ngIf="valid" icon="check" class="text-input__valid-icon text-area__valid-icon"></suka-icon>
      <ng-content select="input,textarea,div"></ng-content>
    </div>
    <div *ngIf="invalid" class="form-requirement">
      <ng-container *ngIf="!isTemplate(invalidText)">{{invalidText}}</ng-container>
      <ng-template *ngIf="isTemplate(invalidText)" [ngTemplateOutlet]="invalidText"></ng-template>
    </div>
  `
})
export class Label implements AfterContentInit {
  /**
   * Used to build the id of the input item associated with the `Label`.
   */
  static labelCounter = 0;
  /**
   * Sets the unique ID. Defaults to `input-${total count of selects instantiated}`
   */
  @Input() id = `input-${Label.labelCounter++}`;
  /**
   * Set to `true` to display a loading label.
   */
  @Input() skeleton = false;
  /**
   * Sets the label helper text.
   */
  @Input() helperText: string;
  /**
   * Sets the invalid text to display when the label is invalid.
   */
  @Input() invalidText: string | TemplateRef<any>;
  /**
   * Set to `true` to display the invalid state.
   */
  @Input() invalid = false;
  /**
   * Set to `true` to display the valid state.
   */
  @Input() valid = false;
  @ViewChild('wrapper', { static: true }) wrapper: ElementRef<HTMLDivElement>;
  @HostBinding('class.form-item') labelClass = true;

  constructor() {
    Label.labelCounter++;
  }

  ngAfterContentInit() {
    this.wrapper.nativeElement.querySelector('input,textarea,div').setAttribute('id', this.id);
  }

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }
}
